import { useState, useEffect, memo, useMemo, FC } from 'react'
import classNames from 'classnames'
import { nanoid } from 'nanoid'

import { getArtistsArray } from '@utils/catalog'
import { Separator } from '@components'
import ArtworksArtist from './ArtworksArtist'
import { Container } from '@mch-group/uikit-components'

const mID = 'artworks-artist-list'

interface Artist {
  artistId: number;
  artistCleanTitle: string;
  artistName: string;
  [key: string]: any;
}

interface ArtworksArtistListProps {
  className?: string;
  artistId: number;
  id: number;
  linkProfile: string;
  artistCleanTitle: string;
  moreFromLabel: string;
  artistName: string;
  sponsorArtists: Artist[];
}

const ArtworksArtistList: FC<ArtworksArtistListProps> = memo(({
  className,
  artistId,
  id,
  linkProfile,
  artistCleanTitle,
  moreFromLabel,
  artistName,
  sponsorArtists
}) => {
  const [artists, setArtists] = useState<Artist[]>([])
  const [loadedArtworks, setLoadedArtworks] = useState<{ [key: number]: number }>({})
  const artworkCounts = useMemo(() => Object.values(loadedArtworks), [loadedArtworks])
  const totalArtworkCount = useMemo(() => artworkCounts.reduce((a, b) => a + b, 0), [artworkCounts])
  const loading = useMemo(() => !artists.length || artworkCounts.length !== artists.length, [artists, artworkCounts])

  useEffect(() => {
    setArtists(getArtistsArray(artistId, artistCleanTitle, artistName, sponsorArtists))
  }, [artistId, artistCleanTitle, artistName, sponsorArtists])

  const onArtworksLoaded = (itemArtistId: number, count: number) =>
    loadedArtworks[itemArtistId] !== count && setLoadedArtworks({ ...loadedArtworks, [itemArtistId]: count })

  return (
    <>
      {(loading || (totalArtworkCount > 0)) && <Separator />}
      <Container className={classNames(mID, className, 'mb-8')}>
        {artists.map(item => (
          <ArtworksArtist
            key={nanoid()}
            {...item}
            moreFromLabel={moreFromLabel}
            id={id}
            linkProfile={linkProfile}
            onArtworksLoaded={(count: number) => onArtworksLoaded(item.artistId, count)}
          />
        ))}
      </Container>
    </>
  )
})

ArtworksArtistList.displayName = 'ArtworksArtistList'

export default ArtworksArtistList
